import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarLabel, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'success-alert-component',
  templateUrl: './success-alert.component.html',
  styleUrl: './success-alert.component.css',
  imports: [MatSnackBarLabel],
  encapsulation: ViewEncapsulation.None,
})
export class SuccessAlertComponent {
  private snackBarRef = inject(MatSnackBarRef<null>);
  public data = inject<string>(MAT_SNACK_BAR_DATA);

  closeSnackBar() {
    this.snackBarRef.dismiss();
  }
}
